import store from "../store.js";
import Vue from "vue";
import keviApi from "../keviApi";

const state = () => ({
    status: "loading",
    filters: {},
    report: {
        periodInDays: 0,
        totalIncome: 0,
        avgTicket: 0,
        avgTimeBetweenOrders: 0,
        newClientsPercentage: 0,
        counters: {
            clients: 0,
            newClients: 0,
            orders: 0,
        },
        absoluteValues: [],
        averageValues: [],
        ordersPerClient: {
            labels: [],
            values: [], //in percentage of clients
        },
    },
});

const actions = {
    loadData({ commit }, filters) {
        commit("setStatus", "loading");
        commit("setFilters", filters);
        let data = {
            filters: filters,
        };
        let requestOptions = keviApi.getOptions("orders/reports", "GET", data);
        Vue.http(requestOptions).then((response) => {
            if (response.status === 200) {
                if (response.body) {
                    commit("setReport", response.body);
                    commit("setStatus", "success");
                } else {
                    commit("setStatus", "empty");
                }
            } else {
                commit("setStatus", "error");
            }
        });
    },
};

const mutations = {
    setStatus(state, status) {
        state.status = status;
    },
    setReport(state, data) {
        state.report = JSON.parse(JSON.stringify(data));
    },
    setFilters(state, data) {
        state.filters = JSON.parse(JSON.stringify(data));
    },
};

store.registerModule("ordersReport", {
    namespaced: true,
    state,
    actions,
    mutations,
});

export default store;
